module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/beian.png
// module id = I5ga
// module chunks = 3